export const newsInitialState = {
  resourceCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: '',
    filterType: 'include',
    platform: 'news',
    componentName: 'resourceCategoryFilter',
    translateKey: 'filter:resourceCategory',
    isDisabled: true,
    hasActivateSwitch: true,
    hasIncludeExclude: true,
  },
  resourcesFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'include',
    selectedItems: {},
    hasIncludeExclude: true,
    platform: 'news',
    componentName: 'resourcesFilter',
    translateKey: 'filter:resourceSearch',
    isDisabled: true,
    hasActivateSwitch: true,
  },
  sentimentFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValues: {
      positive: false,
      neutral: false,
      negative: false,
    },
    platform: 'news',
    componentName: 'sentimentFilter',
    translateKey: 'filter:contentsSentiment',
    isDisabled: true,
    hasActivateSwitch: true,
  },
  resourceTypeFilter: {
    title: 'filter:baseOnResourceType',
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    platform: 'news',
    componentName: 'resourceTypeFilter',
    translateKey: 'filter:resourceType',
    isDisabled: true,
    hasActivateSwitch: true,
  },
  countryFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'countryFilter',
    translateKey: 'filter:country',
    isDisabled: true,
    hasActivateSwitch: true,
  },
  languageFilter: {
    title: 'filter:baseOnLanguage',
    hasFilter: false,
    isOpen: false,
    selectedValue: 'all',
    componentName: 'languageFilter',
    translateKey: 'filter:language',
    isDisabled: true,
    hasActivateSwitch: true,
  },
  contentBasedFilter: {
    hasFilter: false,
    isOpen: false,
    selectedObjects: {
      influenceRate: {
        type: 'checkboxes',
        active: false,
        selectedIds: [],
        label: 'filter:resourceInfluenceRate',
        toggler: 'switch',
      },
    },
    componentName: 'contentBasedFilter',
    translateKey: 'filter:contentBasedOn',
  },
  contentCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    componentName: 'contentCategoryFilter',
    translateKey: 'filter:contentCategory',
    selectedCategories: {},
    isDisabled: true,
    hasActivateSwitch: true,
    openSubCategories: true,
  },
};
